import UserAuthKeys from './UserAuthKeys';
import UserAuthKeysDialog from './UserAuthKeysDialog';

export { UserAuthKeys, UserAuthKeysDialog };
export default UserAuthKeys;
